//import React from 'react'


function AddClientPhone( data , phone , input , who = "client_phone_number" ) {

    phone = phone.replace( "+" , "")



    phone = remove_first_occurrence(phone, input.dialCode)

    data[who] = phone ;

    data.phone_dialcode = input.dialCode ;

    data.phone_iso2 = input.iso2 ;

    data.phone_country = input.name ;

    return data ;

}

function remove_first_occurrence(str, searchstr) {
    // Find the index of the first occurrence of searchstr within str
    var index = str.indexOf(searchstr);
    // If searchstr is not found in str, return str as it is
    if (index === -1) {
        return str;
    }
    // If searchstr is found in str, return a new string that concatenates the substring before the first occurrence of searchstr with the substring after searchstr
    return str.slice(0, index) + str.slice(index + searchstr.length);
}

export default AddClientPhone